module.exports = __webpack_public_path__ + "static/img/tzj_03.0c12ad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh/tzj_03.jpg
// module id = Jmuk
// module chunks = 0